import type { ReactElement } from 'react';

import { KpiStrip, type KpiStripStat } from './KpiStrip.js';

export interface DashboardKPIStat extends KpiStripStat {
  /** Kept for the view-model contract; the D strip renders no per-KPI icons. */
  color: string;
}

export interface TodaysStatsProps {
  stats: readonly DashboardKPIStat[];
  testId?: string;
}

/** KPI band of the dashboard: a single Warm Precision hairline strip. */
export function TodaysStatsWidget({ stats, testId }: TodaysStatsProps): ReactElement {
  return <KpiStrip stats={stats} {...(testId ? { testId } : {})} />;
}
